import React from 'react';
import { Field, FieldArray } from 'redux-form';
import InfiniteScroll from 'react-infinite-scroller';

import Switch from 'components/Fields/ReduxForm/Switch';
import SettingField from 'components/Fields/ReduxForm/SettingField';

import SalesTypeItemVariant from './SalesTypeItemVariant';
import styles from './OutletCheckbox.css';

const ItemVariantField = props => {
  const { member, index } = props;
  return (
    <div className="mk-grouped-input">
      <div className={`form-group col-md-4`}>
        <Field
          name={`item_variants[${index}].name`}
          component={SettingField}
          className="form-control"
          placeholder="Name"
          dis
        />
      </div>
      <div className={'form-group col-md-4 no-padding'}>
        <Field
          name={`${member}.price`}
          component={SettingField}
          maxLength={11}
          placeholder="Price"
          inputClassName="text-right"
          positiveNumberOnly
        />
      </div>
      <div className="item-variant-sales-type-input-sku form-group col-md-4">
        <Field
          name={`item_variants[${index}].sku`}
          component="input"
          className="form-control text-align-last-left"
          placeholder="SKU"
          disabled
        />
      </div>
    </div>
  );
};

const InputComponent = props => {
  const { fields } = props;
  return (
    <div className={styles['input-container']}>
      {fields.map((member, index) => (
        <ItemVariantField
          fields={fields}
          member={member}
          key={index}
          index={index}
        />
      ))}
    </div>
  );
};

class OutletCheckBox extends React.Component {
  render() {
    const {
      fields,
      itemVariantCustom,
      isSalesTypePrice,
      addOutlet,
    } = this.props;
    const defaultValue = { price: undefined, sku: undefined };
    return (
      <div className={`${styles['container-list']}`}>
        <InfiniteScroll
          pageStart={0}
          loadMore={addOutlet}
          hasMore={this.hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}
        >
          {fields.map((outlet, idx) => {
            return (
              <div
                key={outlet}
                className={styles['item-form-section-container']}
              >
                <div className={styles['item-form-section']} key={idx}>
                  <label className={styles['padding-checkbox']}>
                    {fields.get(idx).name}
                    <Field
                      name={`${outlet}.selected_outlet`}
                      component="input"
                      type="checkbox"
                    />
                    <input type="checkbox" />
                    <span className={styles.checkmark} />
                  </label>
                  <Field
                    component={Switch}
                    disabled={!fields.get(idx).selected_outlet}
                    name={`${outlet}.is_custom_price`}
                    type="checkbox"
                  />
                </div>
                {itemVariantCustom[idx].selected_outlet &&
                  itemVariantCustom[idx].is_custom_price && (
                    <div>
                      {isSalesTypePrice ? (
                        <Field
                          name={`item_outlets[${idx}].item_variant_custom_outlet_prices`}
                          component={SalesTypeItemVariant}
                          defaultValue={defaultValue}
                        />
                      ) : (
                        <FieldArray
                          name={`item_outlets[${idx}].item_variant_custom_outlet_prices`}
                          component={InputComponent}
                        />
                      )}
                    </div>
                  )}
              </div>
            );
          })}
        </InfiniteScroll>
      </div>
    );
  }

  hasMore() {
    const { outletList } = this.props;
    const { page, totalpage } = outletList;
    return page < totalpage;
  }
}

export default OutletCheckBox;
